module.exports = __webpack_public_path__ + "assets/img/10cc-ug.svg";